export default ($axios) => ({
  fetch(query) {
    return $axios.get('/whatsapp/campaigns', { params: query }).then((response) => response.data);
  },
});
